export const sanitizeForUrl = (text: string | null | undefined): string => {
    if (!text) return "";

    return text
        .toString()
        .normalize("NFD")                    // remove accents
        .replace(/[\u0300-\u036f]/g, "")     // remove diacritics
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "")        // remove special characters
        .replace(/\s+/g, "-")                // spaces -> dash
        .replace(/-+/g, "-")                 // remove duplicate dashes
        .trim();
};
